import ResultsPerPage from './ResultsPerPage/ResultsPerPage';
import JobDetails from './JobDetails/JobDetails';
import ZipAndDownload from './ZipAndDownload/ZipAndDownload';
import ClearSearch from './ClearSearch/ClearSearch';
import DownloadPDF from './DownloadPDF/DownloadPDF';
import ExportToExcel from './ExportToExcel/ExportToExcel';
import UploadExcel from './UploadExcel/UploadExcel';
import EditJob from './EditJob/EditJob';
import Custom from './Custom/Custom';
import SplitReportButton from './SplitReport/SplitReport_Button/SplitReportButton';
import SplitReport_SingleSample from './SplitReport/SplitReport_SingleSample/SplitReport_SingleSample';

const Actions = {};
Actions.ResultsPerPage = ResultsPerPage;
Actions.JobDetails = JobDetails;
Actions.ZipAndDownload = ZipAndDownload;
Actions.ClearSearch = ClearSearch;
Actions.DownloadPDF = DownloadPDF;
Actions.ExportToExcel = ExportToExcel;
Actions.UploadExcel = UploadExcel;
Actions.EditJob = EditJob;
Actions.Custom = Custom;
Actions.SplitReport = SplitReportButton;
Actions.SplitReport_SingleSample = SplitReport_SingleSample;

export default Actions;
export {
  ResultsPerPage,
  EditJob,
  JobDetails,
  ZipAndDownload,
  ClearSearch,
  DownloadPDF,
  ExportToExcel,
  UploadExcel,
  Custom,
  SplitReportButton,
  SplitReport_SingleSample,
};



// WEBPACK FOOTER //
// ./src/components/Actions/Actions.jsx